var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.984,34.191h-4.321v-5c0-1.104-0.896-2-2-2H50v-3h1.974l7.815,1.95c0.163,0.041,0.325,0.06,0.486,0.06 c0.896,0,1.712-0.607,1.938-1.517c0.268-1.071-0.385-2.157-1.456-2.424l-8.054-2.009c-0.013-0.003-0.025-0.003-0.038-0.005 c-0.07-0.016-0.143-0.023-0.216-0.031c-0.062-0.007-0.124-0.017-0.185-0.019c-0.015,0-0.03-0.005-0.045-0.005h-8.44 c-1.104,0-2,0.896-2,2s0.896,2,2,2H46v3h-4.663c-1.104,0-2,0.896-2,2v5h-4.321c-1.104,0-2,0.896-2,2v37.617c0,1.104,0.896,2,2,2 h25.968c1.104,0,2-0.896,2-2V36.191C62.984,35.087,62.089,34.191,60.984,34.191z M43.337,31.191h9.326v3h-9.326V31.191z  M58.984,71.809H37.016V38.191h4.321h13.326h4.321V71.809z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoap);
export default __webpack_public_path__ + "static/media/soap.1ac5b15391b45f943beff00e6934467a.svg";
export { ForwardRef as ReactComponent };